import { useDateFormat } from '@vivaldis/common'
import { formatDistance, isValid, parseISO } from 'date-fns'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { EmployeeProfileQuery_employee } from '../../../../typings/EmployeeProfileQuery'
import { Information } from '../../../../../Information'
import { NotSetValue } from '../../../NotSetValue'

interface Props {
  employee: EmployeeProfileQuery_employee
}

export const AdditionalInformation = ({ employee }: Props) => {
  const [t] = useTranslation('web_ui')

  const { preferredLanguage, workProfile } = employee
  const phone = employee.mobile

  const formatRetiredOn = useDateFormat('dd/MM/yyyy')

  const lastSeenAt = useMemo(() => {
    if (!employee.lastSeenAt) {
      return null
    }
    const lastSeenAtParsed = parseISO(String(employee.lastSeenAt))

    return isValid(lastSeenAtParsed)
      ? formatDistance(lastSeenAtParsed, new Date(), {
          addSuffix: true
        })
      : null
  }, [employee.lastSeenAt])

  const formattedRetiredOn = useMemo(() => {
    if (!workProfile?.retiredOn) {
      return null
    }
    const retiredOnParsed = parseISO(workProfile.retiredOn)

    return isValid(retiredOnParsed) ? formatRetiredOn(retiredOnParsed) : null
  }, [formatRetiredOn, workProfile?.retiredOn])

  return (
    <>
      <Information.InformationField label={t('employee_profile.last_seen_at')}>
        {lastSeenAt ?? <NotSetValue />}
      </Information.InformationField>

      <Information.InformationField
        label={t('employee_profile.preferred_language')}
      >
        {preferredLanguage ?? <NotSetValue />}
      </Information.InformationField>

      <Information.InformationField label={t('employee_profile.phone')}>
        {phone ?? <NotSetValue />}
      </Information.InformationField>

      <Information.InformationField label={t('employee_profile.email')}>
        {employee.email ?? <NotSetValue />}
      </Information.InformationField>

      <Information.InformationField label={t('employee_profile.is_retired')}>
        {employee?.workProfile?.isRetired === null ||
        employee?.workProfile?.isRetired === undefined ? (
          <NotSetValue />
        ) : employee?.workProfile?.isRetired ? (
          t('yes', { ns: 'translation' })
        ) : (
          t('no', { ns: 'translation' })
        )}
      </Information.InformationField>

      {employee?.workProfile?.retiredOn ? (
        <Information.InformationField label={t('employee_profile.retired_on')}>
          {formattedRetiredOn ?? <NotSetValue />}
        </Information.InformationField>
      ) : null}
    </>
  )
}
